module.exports = __webpack_public_path__ + "img/u2916_div.0b967850.png";